// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPhoto_wrapper__kkRmh"};